(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pagination-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const paginationWrapper = document.querySelector('.pagination-load-more');
    if (!paginationWrapper) return;

    const resultsList = paginationWrapper.closest('results-list');
    if (!resultsList) return;

    const loadMoreButton = paginationWrapper.querySelector('.pagination-load-more__button--next');
    const loadPreviousButton = document.querySelector('.pagination-load-previous__button');

    const updateProductCount = () => {
      const infoText = paginationWrapper.querySelector('.pagination-load-more__text');
      const progressBar = paginationWrapper.querySelector('.pagination-load-more__progress-bar');
      
      // Re-query resultsList in case it was updated
      const currentResultsList = paginationWrapper.closest('results-list');
      if (!currentResultsList || !currentResultsList.refs?.grid) return;

      const grid = currentResultsList.refs.grid;
      const visibleProducts = grid.querySelectorAll('li[data-product-id]').length;
      
      // Get total products from data attribute
      const totalProducts = parseInt(paginationWrapper.dataset.totalProducts) || visibleProducts;
      
      // Update text
      if (infoText) {
        infoText.textContent = `You've Viewed ${visibleProducts} of ${totalProducts} Products`;
      }
      
      // Update progress bar
      if (progressBar && totalProducts > 0) {
        const percentage = Math.min((visibleProducts / totalProducts) * 100, 100);
        progressBar.style.width = `${percentage}%`;
        progressBar.setAttribute('aria-valuenow', visibleProducts);
        progressBar.setAttribute('aria-valuemax', totalProducts);
      }
    };

    const handleLoadMore = async (event) => {
      event.preventDefault();
      
      const button = event.target;
      const originalText = button.textContent;
      
      // Disable both buttons and show loading state
      if (loadMoreButton) loadMoreButton.disabled = true;
      if (loadPreviousButton) loadPreviousButton.disabled = true;
      button.textContent = 'Loading...';

      try {
        // Check if results-list has loadNextPage method
        if (typeof resultsList.loadNextPage === 'function') {
          const hasMore = await resultsList.loadNextPage();
          
          // Wait for DOM to update before updating product count and progress bar
          requestAnimationFrame(() => {
            setTimeout(() => {
              // Update product count and progress bar after loading
              updateProductCount();
            }, 100);
          });
          
          // Update button visibility
          if (!hasMore && loadMoreButton) {
            loadMoreButton.style.display = 'none';
          } else if (loadMoreButton) {
            loadMoreButton.disabled = false;
            loadMoreButton.textContent = 'Load More';
          }

          // Re-enable previous button if it exists
          if (loadPreviousButton) {
            loadPreviousButton.disabled = false;
          }
        } else {
          // Fallback: navigate to next page URL
          const nextUrl = button.dataset.nextUrl;
          if (nextUrl) {
            window.location.href = nextUrl;
          }
        }
      } catch (error) {
        console.error('Error loading more products:', error);
        if (loadMoreButton) {
          loadMoreButton.disabled = false;
          loadMoreButton.textContent = 'Load More';
        }
        if (loadPreviousButton) {
          loadPreviousButton.disabled = false;
        }
      }
    };

    // Attach event listener
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', handleLoadMore);
    }

    // Initial update
    updateProductCount();
  })();
  } catch(e) { console.error(e); }
})();

})();
